"use client";

import type { IAudioPlayerProps } from "@components/core/Audio";
import type { EventName } from "@mw/shared/analyticsEventNames";
import type { PropsWithChildren } from "react";

import { captureEvent } from "@/app/_analytics/analytics";
import { AudioItem } from "@components/core/Audio";

type TrackedAudioItemProps = PropsWithChildren<
  IAudioPlayerProps & {
    trackPlayEvent: EventName;
    trackPlayProperties?: Record<string, unknown>;
  }
>;

export const TrackedAudioItem = ({ trackPlayEvent, trackPlayProperties, ...audioProps }: TrackedAudioItemProps) => {
  return <AudioItem {...audioProps} onPlay={() => captureEvent(trackPlayEvent, trackPlayProperties)} />;
};
